module.exports = __webpack_public_path__ + "static/img/2-0.1a09dd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/two/2-0.png
// module id = 7pJE
// module chunks = 1